<template>
  <v-fab-transition>
    <v-btn
      v-show="show"
      fab
      small
      fixed
      bottom
      right
      color="primary"
      class="scroll-to-top-btn"
      aria-label="Volver al inicio"
      @click="scrollToTop"
    >
      <v-icon>mdi-chevron-up</v-icon>
    </v-btn>
  </v-fab-transition>
</template>

<script>
export default {
  name: "ScrollToTop",
  data() {
    return {
      show: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.show = window.scrollY > 300;
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.scroll-to-top-btn {
  bottom: 32px;
  right: 90px;
  z-index: 248;
}
</style>
